import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AICreditManager from '@/components/billing/AICreditManager';
import SEO from '@/components/common/SEO';
import Header from '@/components/layout/Header';
import CorporateFooter from '@/components/layout/CorporateFooter';
import MainLayout from '@/components/layout/MainLayout';
import { useToast } from '@/components/ui/use-toast';

export default function AICredits() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();
  const checkoutState = searchParams.get('checkout');

  useEffect(() => {
    if (!checkoutState) return;

    if (checkoutState === 'success') {
      toast({
        title: 'Credits added',
        description: 'Your AI credit top-up was completed successfully.',
      });
      window.dispatchEvent(new CustomEvent('mapleos:credits-refresh'));
    }

    if (checkoutState === 'cancelled') {
      toast({
        title: 'Checkout cancelled',
        description: 'No AI credits were added.',
      });
    }

    navigate('/credits', { replace: true });
  }, [checkoutState, navigate, toast]);

  return (
    <MainLayout>
      <SEO
        title="AI Credits"
        description="Manage CanXP AI credits, top-ups, auto top-up settings, and usage history."
        url="/credits"
      />

      <div className="min-h-screen bg-background text-foreground">
        <Header />

        <main className="relative overflow-hidden px-4 py-12 md:py-16">
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.18),transparent_34rem)]" />
          <div className="absolute left-1/2 top-20 -z-10 h-72 w-72 -translate-x-1/2 rounded-full bg-primary/10 blur-3xl" />

          <div className="mx-auto max-w-3xl text-center">
            <p className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
              CanXP AI Credits
            </p>
            <h1 className="mt-5 text-4xl font-bold tracking-tight md:text-6xl">
              Manage your AI credits
            </h1>
            <p className="mt-4 text-lg text-muted-foreground md:text-xl">
              Use as much or as little as you want. Auto top-up or add credits as you need it.
            </p>
          </div>

          <div className="mx-auto mt-10 max-w-5xl">
            <AICreditManager embedded />
          </div>
        </main>

        <CorporateFooter />
      </div>
    </MainLayout>
  );
}
